import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PiesyncIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Piesync",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.05 17.63c0 .64-.52 1.16-1.16 1.17h-3.55c-.64 0-1.16-.53-1.16-1.17v-3.54c0-.64.52-1.16 1.16-1.17h3.55c.64 0 1.16.53 1.16 1.17z"
    }), /*#__PURE__*/_jsx("path", {
      d: "m29.76 12.68-5.93-8.02c-.18-.31-.5-.52-.86-.55v16.44c0 1.35-1.1 2.45-2.45 2.45h-7.33v4.89h7.33c4.05 0 7.34-3.29 7.34-7.34v-6.53h1.18c.9 0 1.23-.58.72-1.34"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.03 16.6v-5.19c0-1.35 1.09-2.45 2.45-2.46h9.41V4.1h-9.41c-4.04 0-7.32 3.27-7.34 7.31v6.47H2.95c-.89 0-1.22.61-.71 1.35l5.93 8.02c.19.31.51.51.86.55z"
    })]
  }));
};